import getFormData from '@/util/form-data';
import httpClient from './http-client';

const endpoint = 'api/users';

const getUserImportFormData = (userImportData) => {
  const fieldBlacklist = [];

  return getFormData(userImportData, fieldBlacklist);
};

const userService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  getCurrent: () => httpClient.get(`${endpoint}/current`),

  getAccompanyingUser: async (search) => {
    const res = await httpClient.post(`${endpoint}/find-accompanying-user`, { search });
    return {
      ...res,
      data: res.data.data.map((user) => ({
        id: user.id,
        person: {
          full_name: user.full_name,
        },
      })),
    };
  },

  search: (search) => httpClient.post(`${endpoint}/find`, { search }),

  searchCanCreatePermitUsers: (search) =>
    httpClient.post(`${endpoint}/find`, { search, can_create_driving_permit: true }),

  create: (user) => httpClient.post(`${endpoint}`, user),

  update: (user) => httpClient.put(`${endpoint}/${user.id}`, user),

  delete: (user) => httpClient.delete(`${endpoint}/${user.id}`),

  toggleStatus: (user) => httpClient.patch(`${endpoint}/${user.id}/toggle-suspend`),

  resetPassword: (user) => httpClient.post(`${endpoint}/${user.id}/reset-password`, user),

  changeCurrentUserPassword: (payload) => httpClient.put(`${endpoint}/current/password`, payload),

  getImportFileExample: () =>
    httpClient({
      url: 'api/user-import-file-example',
      method: 'GET',
      responseType: 'blob',
    }),

  importUsers: (importPayload) => {
    const formData = getUserImportFormData(importPayload);

    return httpClient.post(`${endpoint}-import`, formData);
  },

  exportUsersXlsx: (params) =>
  httpClient({
    url: 'api/users-export',
    method: 'GET',
    params,
    responseType: 'blob',
  }),

  getUsersWithPermits: () => httpClient.get('api/users-with-permits'),

  suspendUsers: (ids) => httpClient.post('api/suspend-users', { user_ids: ids }),

  checkPersonData: (id) => httpClient.get(`api/check-person-data/${id}`),

  updatePerson: (person) => httpClient.put(`api/update-person/${person.id}`, person),

  getCurrentUserIp: () => httpClient.get('api/current-user-ip'),

  sendEmailActiveSubjectAdmins: (payload) => 
    httpClient.post('api/users/email-active-subject-admins', getFormData(payload)),

  updateUserProfile: (payload) => httpClient.put('api/users/profile', payload),
};

export default userService;
